import { useRef, useState } from 'react';
import './MyAccountDropDown.scss';
import { useTranslation } from 'react-i18next';
import { AVAILABLE_LANGUAGES } from '../../../i18n';
import { Popup, PopupTheme } from '../components/Popup/Popup';
import classNames from 'classnames';

export const LanguageSelector = () => {
    const { i18n, t } = useTranslation();

    const [expanded, setExpanded] = useState(false);

    const ref = useRef<HTMLParagraphElement>(null);

    return (
        <div className="language">
            <p className="language-label" onClick={() => setExpanded(!expanded)} ref={ref}>
                {t('language')}{' '}
                <i style={{ color: 'white' }} className={classNames('material-icons', 'md-uppest')}>
                    {expanded ? 'expand_less' : 'expand_more'}
                </i>
            </p>
            <Popup
                placement="bottom-end"
                target={ref}
                theme={PopupTheme.LIGHT}
                onClose={() => setExpanded(false)}
                visible={expanded}
                portal={false}
            >
                {AVAILABLE_LANGUAGES.map(({ id, key }) => (
                    <li key={id}>
                        <button
                            className="language-selector"
                            value={id}
                            onClick={() => {
                                i18n.changeLanguage(id).then();
                                setExpanded(false);
                            }}
                        >
                            {t(key)}
                        </button>
                    </li>
                ))}
            </Popup>
        </div>
    );
};
